import DateUtility from './lib/dateUtility';
import React from 'react';
import { ReactRenderer } from './lib/ReactRenderer';
import { MoreButton, Missing, parseAsSection, parseVisibleCount, SectionHead, ShiftList, ShiftPageHead, ShiftRow, UrgentPill } from './lib/shiftList';
export default class YellowShiftListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            visible: this.limit()
        };
        this.gridElement = document.getElementById(this.props.elementId).closest(".umb-block-grid__layout-item");
    }
    componentDidMount() {
        fetch(`/bpapi/yellowshift/future`, { method: 'GET' })
            .then((response) => {
            return (response.ok) ? response.json() : Promise.reject(`${response.status} ${response.statusText}`);
        })
            .then((result) => {
            this.setState({ isLoaded: true, list: result });
        })
            .catch((error) => {
            console.error(error);
            this.setState({ isLoaded: true, list: [] });
        });
    }
    /** The "Antal vagter" of the block; zero shows the whole list. */
    limit() {
        return parseVisibleCount(this.props.visiblecount);
    }
    /** "Show as section" of the block: the small head of the front page, or a page of its own. */
    asSection() {
        return parseAsSection(this.props.assection);
    }
    renderList(items, total) {
        const more = this.limit() > 0 && items.length < total
            ? React.createElement(MoreButton, { onClick: () => this.setState({ visible: this.state.visible + this.limit() }) })
            : null;
        return (React.createElement(ShiftList, { list: "gule", items: items, start: (item) => DateUtility.parse(item.dtStart), columns: ["Vagt", "", "Mangler", "Film", ""], footer: more, renderRow: (item) => {
                const missingShops = Math.max(item.neededShops - item.filledShops, 0);
                return (React.createElement(ShiftRow, { list: "gule", href: `/vagtinfo/?shiftId=${item.id}`, start: DateUtility.parse(item.dtStart), end: DateUtility.parse(item.dtEnd), events: item.events, urgent: item.isRedShift, notes: item.notes, context: React.createElement(React.Fragment, null,
                        item.isRedShift ? React.createElement(UrgentPill, null) : null,
                        !item.hasOperator ? React.createElement(Missing, { role: "Operator" }) : null,
                        !item.hasShops ? React.createElement(Missing, { role: "Shop", count: missingShops }) : null) }));
            } }));
    }
    render() {
        if (!this.state.isLoaded) {
            return (React.createElement("div", { className: "bp-loading" },
                React.createElement("i", { className: "fa fa-spinner fa-pulse fa-fw" })));
        }
        const list = this.state.list;
        const title = this.props.headline || "Gule vagter";
        const subtitle = "Her har du mulighed for at tage en ekstra tjans.";
        if (list.length === 0) {
            if (this.props.showalways === "1") {
                this.gridElement.style.display = "";
                return (React.createElement("div", { className: "bi-sl-page" },
                    React.createElement(ShiftPageHead, { title: title, subtitle: "Der er i \u00F8jeblikket ingen gule vagter, du kan melde dig p\u00E5." })));
            }
            this.gridElement.style.display = "none";
            return (React.createElement(React.Fragment, null));
        }
        this.gridElement.style.display = "";
        const shown = this.limit() > 0 ? list.slice(0, this.state.visible) : list;
        if (this.asSection()) {
            return (React.createElement("section", { className: "bi-sl-section" },
                React.createElement(SectionHead, { title: title, count: list.length, href: "/gule-vagter" }),
                React.createElement("div", { className: "bi-sl-card" }, this.renderList(shown, list.length)),
                React.createElement("p", { className: "bi-sl-section-note" }, subtitle)));
        }
        return (React.createElement("div", { className: "bi-sl-page" },
            React.createElement(ShiftPageHead, { title: title, subtitle: subtitle, count: list.length }),
            this.renderList(shown, list.length)));
    }
}
ReactRenderer.render("yellowshiftlistcomponent", (elem) => React.createElement(YellowShiftListComponent, Object.assign({}, (elem.dataset))));
